import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import SliceR from "../components/slice-r";
import { translateColorToRGB } from '../utility';

const PageTemplate = ({ pageContext }) => {
  const page = pageContext.node.data;

  // Get dynamic gradient colors from Prismic
  const leftColor = page.left_color ? translateColorToRGB(page.left_color) : "255,67,56";
  const rightColor = page.right_color ? translateColorToRGB(page.right_color) : "0,188,180";

  return (
    <Layout>
      <SEO
        title={page.meta_title}
        image={page.meta_og_image?.url}
        noindex={page.meta_noindex}
        description={page.meta_description}
        canonical={
          typeof window !== "undefined" &&
          window.location.origin + window.location.pathname
        }
      />

      {/* OPTIONAL HERO SECTION */}
      {page.has_hero && page.wide_image?.url && (
        <div
          className="title-bar title-bar-xl banner-custom-page"
          style={{
            backgroundImage: page.split_color_overlay ? `
              linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(0,0,0,0.2)),
              linear-gradient(to right, rgba(${leftColor},0.6) 0%, transparent 45%, transparent 55%, rgba(${rightColor},0.6) 100%),
              url(${page.wide_image.url})
            ` : `url(${page.wide_image.url})`
          }}
        >
          <div className="container">
            <a href="" className="page-scroll">
              <span className="icn-arrows-down">[Down Arrow]</span>
            </a>
            <div className="wrapper">
              {page.page_title && (
                <h2 className="page-title">
                  {page.page_title.text}
                </h2>
              )}
              {page.page_subtitle && (
                <p className="page-subtitle">{page.page_subtitle}</p>
              )}
              <div className="title-bar-accent"></div>
            </div>
          </div>
        </div>
      )}

      {/* PAGE BODY - with no-hero class if hero is disabled */}
      <section id="body-area" className={!page.has_hero ? 'no-hero' : ''}>
        <div className="container">
          {/* If no hero, show title here */}
          {!page.has_hero && page.page_title && (
            <div className="page-content-header">
              <h1 className="headline">{page.page_title.text}</h1>
              {page.page_subtitle && (
                <p className="page-subtitle-text">{page.page_subtitle}</p>
              )}
            </div>
          )}

          {/* FLEXIBLE SLICE AREA */}
          <div className="page-slices">
            {page.body && page.body.map((slice, index) => (
              <SliceR key={index} data={slice} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PageTemplate;
